import BoxUi from '@components/common/BoxUi';
import IconSwitcher from '@components/common/IconSwitcher';
import TitleUi from '@components/common/TitleUi';
import { CSS_HELPERS, MEDIA_SCREENS, THEME_COLORS } from '@theme/constants';
import { Typography } from 'antd';
import _ from 'lodash';
import styled from 'styled-components';

const IndicadorRentabilidad = ({ data }) => {

    const { document } = data;
    console.log({ document });

    const rendimiento = transposeHandler([
        ...document.rendimiento,
        // ...document.valor_unidad_historico
    ]);



    return (
        <BoxUi background>
            <TitleUi
                titulo="Rentabilidad de Fondos"
                descripcion_corta="Nos interesa mantenerte informado, conoce el comportamiento de tus Fondos de Inversión."
            />
            <Grid>
                {rendimiento.map(item => (
                    <Item key={item.icon}>
                        <Card>
                            <CardHeader>
                                <IconCircle>
                                    {(() => console.log(item.icon))()}
                                    <IconSwitcher name={`${item.icon === 'estratégico' ? 'estrategico' : item.icon}`} />
                                </IconCircle>
                            </CardHeader>


                            <CardBody>
                                <Typography.Title level={5}>
                                    {item.fondo}
                                </Typography.Title>
                                {item.data.map((rendimiento, index) => {

                                    // const indicador =
                                    // index === item.data.length - 1 ? <BsDot /> :
                                    //     rendimiento.monto >= item.data[index + 1].monto ? <BsArrowUpCircleFill color={THEME_COLORS.alerts.success.main} /> :
                                    //         rendimiento.monto <= item.data[index + 1].monto ? <BsArrowDownCircleFill color={THEME_COLORS.alerts.danger.main} /> : ""


                                    return (
                                        <div className="rendimiento" key={rendimiento.fecha}>
                                            <p className="xs">
                                                {rendimiento.fecha}
                                            </p>

                                            <p className="xs">
                                                {rendimiento.monto.toFixed(2)}%
                                            </p>

                                        </div>
                                    )
                                }
                                )}
                            </CardBody>

                        </Card>
                    </Item>))}
            </Grid>
        </BoxUi>


    )
}

export default IndicadorRentabilidad;


const getOrder = (slug) => {
    switch (slug) {
        case "horizonte": return 0;
        case "rentaplus": return 1;
        case "superior": return 2;
        case "eficaz": return 3;
        case "estratégico": return 4;
        case "master": return 5;
        default: return 0
    }
}


const transposeHandler = (data) => {



    const groupByFecha = _.groupBy(data, item => item.fondo);
    const elements = Object.keys(groupByFecha).map(function (key) {
        const currElements = groupByFecha[key];
        return {
            fondo: key,
            icon: key.split(" ")[1].toLocaleLowerCase(),
            data: currElements,
            order: getOrder(key.split(" ")[1].toLocaleLowerCase())
        }
    });

    return _.orderBy(elements, item => item.order);

};


const Grid = styled.div`
/* width:100%;
    display: flex;
    justify-content: center;
    flex-flow: wrap; */
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    width: 60%;
    margin: auto;

    @media screen and  (min-width: ${0}px) and (max-width: ${MEDIA_SCREENS.MD}px) {
        grid-template-columns: 1fr;
        width: 100%;
    }
`;

const Item = styled.div`
    padding:1em;
    @media screen and  (min-width: ${0}px) and (max-width: ${MEDIA_SCREENS.MD}px) {
        width:80%;
        margin: auto;
    }
    
    /* @media screen and  (min-width: ${MEDIA_SCREENS.LG}px)  { 
        width:20%;
    }
    @media screen and  (min-width: ${MEDIA_SCREENS.MD}px) and (max-width: ${MEDIA_SCREENS.LG}px) { 
        width:20%;
    };
    @media screen and  (min-width: ${MEDIA_SCREENS.SM}px) and (max-width: ${MEDIA_SCREENS.MD}px) { 
        width:27%;
    }
    @media screen and  (min-width: ${MEDIA_SCREENS.XS}px) and (max-width: ${MEDIA_SCREENS.SM}px) { 
        width:80%;
    }
    @media screen and  (min-width: ${0}px) and (max-width: ${MEDIA_SCREENS.XS}px) { 
        width:80%;
    } */
`;

const Card = styled.div`
    width: 100%;
    display:flex;
    flex-direction: column;
    align-items:center ;
    border-radius:3em;
    overflow: hidden;
    ${CSS_HELPERS.BOX_SHADOW};
`;

const CardHeader = styled.div`
    /* background: linear-gradient(201deg, rgba(40,143,212,1) 5%, rgba(22,96,155,1) 88%); */
    background:${THEME_COLORS.light.bg.main};
    display:flex;
    width: 100%;
    display: flex;
    justify-content:center ;
    padding: 1em;
    border-bottom: 2pt solid ${THEME_COLORS.light.secondary.main};
`;


const IconCircle = styled.div`
    /* background: linear-gradient(201deg, rgba(40,143,212,1) 5%, rgba(22,96,155,1) 88%); */
    border: 2pt solid ${THEME_COLORS.light.secondary.main};
    width:6em;
    height:6em;
    display:flex;
    justify-content:center;
    align-items:center;
    border-radius:50% ;
    svg{
        /* fill:${THEME_COLORS.light.primary.contrastText}; */
        fill: ${THEME_COLORS.light.primary.main};
    };
`


const CardBody = styled.div`
    background: linear-gradient(201deg, rgba(40,143,212,1) 5%, rgba(22,96,155,1) 88%);
    width: 100%;
    background-color:white;
    padding:1em 1em 2em 1em;
    .ant-typography, p { color: ${THEME_COLORS.light.primary.contrastText}}
    p{
      padding: 0.3em;
    }
    .rendimiento{
        width:100%; 
        display:flex;
        gap:1em;
        justify-content:space-between;
        align-items:center; 
    };
`;
